export default __webpack_public_path__ + "static/media/30inex_04.ad3a265c.png";